import 'whatwg-fetch';

export default class HttpRequestor {
  constructor() {
    this.nextCsrfToken = null;
  }

  call(url, method, body = {}) {
    let args = {
      method: method,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
      },
      body: body,
      credentials: 'same-origin',
    };

    if (~['POST', 'PATCH', 'PUT', 'DELETE'].indexOf(method)) {
      const token = this.csrfToken();
      args.headers['X-CSRF-Token'] = token;
      args.body = JSON.stringify(args.body);
    }

    if (~['GET', 'HEAD'].indexOf(method)) {
      delete args.body;
    }

    return fetch(url, args).then(this.handleErrors).then(this.handleResponse);
  }

  handleErrors(response) {
    if (!response.ok) {
      const json = response.json();
      return Promise.reject(json);
    }
    return response;
  }

  handleResponse(response) {
    if (response.status == 204) {
      return null;
    }

    try {
      return response.json();
    } catch (e) {
      return response;
    }
  }

  csrfToken() {
    const csrf_element = document.querySelector('meta[name=csrf-token]');
    const token = this.nextCsrfToken || (csrf_element && csrf_element.getAttribute('content'));
    return token;
  }
}
